import { CalculatorApi } from './calculator-api-service';
import { FamilyFormState } from "./../models/FamilyFormState";
import { calculationMapper } from '../mappers/calculation-mapper';
import { calculationResultMapper } from '../mappers/calculation-result-mapper';

const MOCK = false;

export const CalculatorService = {
  async calculate(data: {
    family: FamilyFormState;
    children: FamilyFormState[];
    apiUrl: string;
  }) {
    if (MOCK) {
      return await CalculatorService.calculateMock()
    }

    const payload = calculationMapper(data.family, data.children);
    const result = await CalculatorApi.calculate(payload, data.apiUrl);
    const mappedResult = calculationResultMapper(result);
    return mappedResult;
  },

  async calculateMock(...args: any) {
    const result = await CalculatorApi.calculateMock();
    const mappedResult = calculationResultMapper(result);
    return mappedResult;
  }
};
